// Port of api/fuel/app/classes/insights/members/size.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Insight from 'offline/model/insight'
import Util from 'offline/util'

function shiftMonth(timestamp, months) {
	var date = new Date(timestamp * 1000)
	date.setDate(1)
	date.setHours(0, 0, 0, 0)
	date.setMonth(date.getUTCMonth() + months)
	return Math.floor(date.getTime() / 1000)
}

export default Segment.extend({
	name: 'size',
	types: [Constants.TYPE_GROUP],
	insight: false,
	detail: false,
	run: function(type, owner) {
		var activity = []
		var currentMonth = Util.time()

		var size = Insight.collection({
			where: [
				['group_id', '=', owner.get_id()],
				['insight_type', '=', Constants.INSIGHT_TYPE_MEMBERS_SIZE],
				['insight_period', '=', Constants.INSIGHT_PERIOD_MONTH]
			],
			order_by: 'insight_date DESC',
			limit: 12
		}).associated('insight_stamp')

		var added = Insight.collection({
			where: [
				['group_id', '=', owner.get_id()],
				['insight_type', '=', Constants.INSIGHT_TYPE_MEMBERS_ADDED],
				['insight_period', '=', Constants.INSIGHT_PERIOD_MONTH]
			],
			order_by: 'insight_date DESC',
			limit: 12
		}).associated('insight_stamp')

		var removed = Insight.collection({
			where: [
				['group_id', '=', owner.get_id()],
				['insight_type', '=', Constants.INSIGHT_TYPE_MEMBERS_REMOVED],
				['insight_period', '=', Constants.INSIGHT_PERIOD_MONTH]
			],
			order_by: 'insight_date DESC',
			limit: 12
		}).associated('insight_stamp')

		for (var i = 12; i >= 1; i--) {
			var stamp = Util.date('m.y', currentMonth)
			activity.push({
				month: Util.date('m/y', currentMonth),
				added: added[stamp] ? parseInt(added[stamp].get_insight_value(), 10) || 0 : 0,
				removed: removed[stamp] ? parseInt(removed[stamp].get_insight_value(), 10) || 0 : 0,
				size: size[stamp] ? parseInt(size[stamp].get_insight_value(), 10) || 0 : 0
			})
			currentMonth = shiftMonth(currentMonth, -1)
		}

		activity.reverse()

		return {
			activity: activity,
			totalMembers: activity.length ? (parseInt(activity[activity.length - 1].size, 10) || 0) : 0
		}
	}
})
